export const ACCESS_TOKEN = "@/cq_audit/auth_token"
export const REFRESH_TOKEN = "@/cq_audit/refresh_token"